var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.20001 10.8V16.2C7.20001 16.71 7.37281 17.1378 7.71841 17.4834C8.06401 17.829 8.49121 18.0012 9.00001 18C9.51001 18 9.93781 17.8272 10.2834 17.4816C10.629 17.136 10.8012 16.7088 10.8 16.2V10.8H16.2C16.71 10.8 17.1378 10.6272 17.4834 10.2816C17.829 9.936 18.0012 9.50881 18 9.00001C18 8.49001 17.8272 8.06221 17.4816 7.71661C17.136 7.37101 16.7088 7.19881 16.2 7.20001H10.8V1.80001C10.8 1.29001 10.6272 0.862207 10.2816 0.516607C9.936 0.171007 9.50881 -0.00119377 9.00001 6.22835e-06C8.49001 6.22835e-06 8.06221 0.172806 7.71661 0.518406C7.37101 0.864006 7.19881 1.29121 7.20001 1.80001V7.20001H1.80001C1.29001 7.20001 0.862207 7.37281 0.516607 7.71841C0.171007 8.06401 -0.00119377 8.49121 6.22835e-06 9.00001C6.22835e-06 9.51001 0.172806 9.93781 0.518406 10.2834C0.864006 10.629 1.29121 10.8012 1.80001 10.8H7.20001Z",
    fill: "#ffffff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddCircle);
export default __webpack_public_path__ + "static/media/add-circle.6a234e8cdd5ffe20fb0bf025f3335184.svg";
export { ForwardRef as ReactComponent };